import { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { analysesApi } from '../../features/analyses/api'

export default function SynchroChangelog() {
  const [changelog, setChangelog] = useState('')
  const [version, setVersion] = useState('')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function loadChangelog() {
      try {
        const response = await analysesApi.getSynchroChangelog()
        setChangelog(response.data.content)
        setVersion(response.data.current_version)
      } catch (err) {
        setError('Failed to load changelog')
        console.error('Error loading changelog:', err)
      } finally {
        setLoading(false)
      }
    }
    loadChangelog()
  }, [])

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="text-gray-600">Loading changelog...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="text-red-600">{error}</div>
      </div>
    )
  }

  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      {version && (
        <div className="mb-6 inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
          Current Version: {version}
        </div>
      )}

      <div className="prose prose-slate max-w-none prose-headings:font-bold prose-h1:text-3xl prose-h2:text-2xl prose-h3:text-xl prose-h4:text-lg prose-a:text-blue-600 prose-code:text-sm prose-code:bg-gray-100 prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-code:text-gray-800 prose-code:before:content-none prose-code:after:content-none prose-pre:bg-gray-50 prose-pre:text-gray-800 prose-pre:border prose-pre:border-gray-200 prose-p:leading-normal prose-li:leading-normal">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{changelog}</ReactMarkdown>
      </div>
    </div>
  )
}
